export const PLANS = [
  {
    key: "harbour",
    name: "Harbour",
    price_month: "Free",
    price_year: "",
    products: "Company profile only",
    tagline: "Be listed. Cross as a guest.",
    summary: "A free company entry in the sector directory. No product or service listings.",
    features: [
      "One free company profile in the directory",
      "Listed by sector on both-shore search",
      "Enquiries visible in your account",
      "Forum: one contribution",
    ],
    badge: false,
  },
  {
    key: "stump",
    name: "Stump",
    price_month: "£5/mo",
    price_year: "or £50/yr",
    products: "Up to 3 product/service listings",
    tagline: "Start trading across the crossing.",
    summary: "Publish up to three products or services, earn the gold Stump mark, and post freely in the forum.",
    features: [
      "Everything in Harbour",
      "Up to 3 product / service listings",
      "Gold “Stump member” mark",
      "Unlimited forum posting",
    ],
    badge: true,
  },
  {
    key: "beacon",
    name: "Beacon",
    price_month: "£12/mo",
    price_year: "or £120/yr",
    products: "Up to 15 product/service listings",
    tagline: "Be seen across both shores.",
    summary: "Up to fifteen listings, a featured row on the directory, and eligibility for the homepage berth.",
    features: [
      "Everything in Stump",
      "Up to 15 product / service listings",
      "Featured row on the Made directory",
      "Eligible for Crossing of the week",
    ],
    badge: true,
    popular: true,
  },
  {
    key: "crossing",
    name: "Crossing",
    price_month: "£20/mo",
    price_year: "or £200/yr",
    products: "Unlimited listings",
    tagline: "Trade fully on both shores.",
    summary: "Unlimited products, multi-shore placement, a homepage week, and a presence in the 2030 ledger.",
    features: [
      "Everything in Beacon",
      "Unlimited product / service listings",
      "Multi-shore (both harbours)",
      "Homepage week & 2030 presence",
    ],
    badge: true,
  },
];
